import ccChart from '../../colicare/colicarechart';
import ccCompare from './colicarecomparechart';
import colicare from './colicare';

colicare.init();
ccCompare.init();
ccChart.updateChartPrices();
